import { render } from "./UploadedFilesDialog.vue?vue&type=template&id=da091f3e&scoped=true"
import script from "./UploadedFilesDialog.vue?vue&type=script&lang=js"
export * from "./UploadedFilesDialog.vue?vue&type=script&lang=js"

import "./UploadedFilesDialog.vue?vue&type=style&index=0&id=da091f3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da091f3e"]])

export default __exports__